import FanpagePage from "./FanpageContainer";

export default FanpagePage;
